import { render, staticRenderFns } from "./AllRequests.vue?vue&type=template&id=4dd7d95d&scoped=true&"
import script from "./AllRequests.vue?vue&type=script&lang=js&"
export * from "./AllRequests.vue?vue&type=script&lang=js&"
import style0 from "./AllRequests.vue?vue&type=style&index=0&id=4dd7d95d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd7d95d",
  null
  
)

export default component.exports